import { render, staticRenderFns } from "./ViewTwo.vue?vue&type=template&id=48eba556&scoped=true"
import script from "./ViewTwo.vue?vue&type=script&lang=js"
export * from "./ViewTwo.vue?vue&type=script&lang=js"
import style0 from "./ViewTwo.vue?vue&type=style&index=0&id=48eba556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eba556",
  null
  
)

export default component.exports